import { Error } from '@/components/error';

const ErrorUnknown = () => <Error variant='unknown' />;

export { ErrorUnknown };
